import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '../../../../components/Box';
import ColumnChooser from '../../../../components/ColumnChooser';
import CustomMultiSelect from '../../../../components/CustomMultiSelect';
import CustomSingleSelect from '../../../../components/CustomSingleSelect';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import Filters from '../../../../components/Filters';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetEk83ReportListPagingAndFilterRequest } from '../../../../models/request/report/GetEk83ReportListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetEk83ReportListPagingAndFilterRequest
    getData: (_filter?: GetEk83ReportListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetEk83ReportListPagingAndFilterRequest>>
}

const Ek83ReportListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={0}
                allowSelected={false}
                onExport={excelExport}
            />

            <Filters
                filter={filter}
                getData={getData}
                onReset={() => getData({ ...filter, startDate: '', endDate: '', selectedReceiverFirm: undefined, currentPage: 1, skip: 0 })}
            >
                <div className='mb-5'>
                    <label className='form-label fw-bold required'>Başlangıç Tarihi:</label>

                    <Box flexDirection='row'>
                        <Box flex={1} justifyContent='center'>
                            <input
                                className="form-control form-control-solid"
                                type={'date'}
                                value={filter.startDate}
                                onChange={(e) => setFilter({
                                    ...filter,
                                    startDate: e.target.value
                                })}
                            />
                        </Box>
                    </Box>
                </div>

                <div className='mb-5'>
                    <label className='form-label fw-bold required'>Bitiş Tarihi:</label>

                    <Box flexDirection='row'>
                        <Box flex={1} justifyContent='center'>
                            <input
                                className="form-control form-control-solid"
                                type={'date'}
                                value={filter.endDate}
                                onChange={(e) => setFilter({
                                    ...filter,
                                    endDate: e.target.value
                                })}
                            />
                        </Box>
                    </Box>
                </div>

                <div>
                    <label className='form-label fw-bold'>Alıcı Firma:</label>

                    <div>
                        <CustomSingleSelect
                            onChange={(e) => setFilter({
                                ...filter,
                                selectedReceiverFirm: e
                            })}
                            selectedValue={filter.selectedReceiverFirm}
                            onMenuOpen={[
                                () => CompanyService.getCompanyList({ isReceiverFirm: true }),
                                () => CompanyService.getCompanyList({ isCustomer: true }),
                            ]}
                            labelName='name'
                            valueName='companyId'
                        />
                    </div>
                </div>
            </Filters>
        </React.Fragment>
    )
}

export default Ek83ReportListFilters;